import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { Constant } from 'src/app/constants/constant';
import { AnalyticService } from 'src/app/services/analytic-service';
import { CheckoutService } from 'src/app/services/checkout.service';
import { CommonService } from 'src/app/services/common.service';
import { ContactService } from 'src/app/services/contact.service';
import { DeployService } from 'src/app/services/deploy.service';
import { PixelService } from 'src/app/services/pixel.service';
import { SupplierRegistrationService } from 'src/app/services/supplier-registration.service';
import { FieldConfig } from 'src/app/shared/component/field.interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'calsoft-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss']
})
export class ContactFormComponent implements OnInit {
  get isFormHiddenOnChan(): boolean {
    const isChan = this.router.url.split('?')[0] === '/indianabacus-prebooking';
    const isSubmitted = localStorage.getItem('formSubmittedOnChan') === 'true';
    return isChan && isSubmitted;
  }
  text: string;
  firstFormGroup: UntypedFormGroup;
  @Input() input: any;
  @Input() whiteFields: any = false;
  @Input() data: any;
  @Input() item: any;

  @Input() noPadding: any = false;

  disabledButton: any = false;

  type: any;

  customField31: any;

  regConfig: any[] = [

  ];
  init: boolean = false;
  gaId: any;
  formGroupId: any;
  customField13: any;
  customField8: any;
  customField5: any;
  customField4: any;
  customField28: any = 'Form Submitted SuccessFully';
  customField29: any = 'Form Submitted Failed';
  customField10: any = '/home';
  layout: number;
  calculatedResult: number;
  customField32: any;
  customField33: any;
  customField24: any;
  customField25: any;

  constructor(private _formBuilder: UntypedFormBuilder,
    private router: Router,
    private snackBar: MatSnackBar,
    public googleAnalyticsService: AnalyticService,
    private contactService: ContactService,
    private pixelService: PixelService,
    private checkoutService: CheckoutService,
    private supplierRegistrationService: SupplierRegistrationService,
    private deployService: DeployService) { }

  alignMent: any = 2;
  fieldData = [
    { label: 'Name', controlName: 'name', type: 'text' },
    { label: 'Telephone', controlName: 'telephone', type: 'text' },
    { label: 'Subject', controlName: 'subject', type: 'textarea' },
    { label: 'Email Id', controlName: 'emailId', type: 'text' },
    { label: 'Message', controlName: 'message', type: 'textarea' },
  ];

  getFormFields(fieldCount: number, fields: any[]): any[] {
    const result = [];
    for (let i = 0; i < fields.length; i++) {
      if (i % fieldCount === 0) {
        result.push(fields[i]);
      } else {
        result.splice(i % fieldCount, 0, fields[i]);
      }
    }
    return result;
  }
  getMobileFlexValue(customField27: any = 1): string {

    return customField27 === 2 ? '50%' : customField27 === 3 ? '33.33%' : '100%';
  }

  getFlexValue(columns: number): string {

    const columnCount = columns ?? 1;

    switch (columnCount) {
      case 2: return '50%'; // Two fields per row
      case 3: return '33.33%'; // Three fields per row
      case 4: return '25%'; // Four fields per row
      default: return '100%'; // One field per row
    }
  }

  ngOnInit(): void {

    if (window.innerWidth > 600) {
      this.layout = this.item.customField26 ? parseInt(this.item.customField26) : 2; // Default to 2 if customField26 is empty
    } else {
      this.layout = this.item.customField27 ? parseInt(this.item.customField27) : 1; // Default to 1 for mobile views
    }

    if (window.innerWidth > 600) {


      if (this.item.customField26 != '') {
        this.alignMent = this.item.customField26
      }




    } else {
      if (this.item.customField27 != '') {
        this.alignMent = this.item.customField27
      }
    }



    if (this.item['customField30'] != undefined) {
      this.type = parseInt(this.item['customField30'])


    } else {
      this.type = 0;

    }
    if (this.item.customField32 != undefined) {
      this.customField32 = this.item.customField32;
    }
    if (this.item.customField33 != undefined) {
      this.customField33 = this.item.customField33;
    }

    if (this.item.customField31 != undefined) {
      this.customField31 = this.item.customField31;
    }

    if (this.item.customField13 != undefined) {
      this.customField13 = this.item.customField13;
    }

    if (this.item.customField5 != undefined) {
      this.customField5 = this.item.customField5;
    }

    if (this.item.customField4 != undefined) {
      this.customField4 = this.item.customField4;
    }
    if (this.item.customField24 != undefined) {
      this.customField24 = this.item.customField24;
    }
    if (this.item.customField25 != undefined) {
      this.customField25 = this.item.customField25;
    }

    if (this.item.customField8 != undefined) {
      this.customField8 = this.item.customField8;
    }

    if (this.item.customField28 != undefined) {
      this.customField28 = this.item.customField28;
    }

    if (this.item.customField29 != undefined) {
      this.customField29 = this.item.customField29;
    }

    if (this.item.customField10 != undefined) {
      this.customField10 = this.item.customField10;
    }


    if (this.type == 0) {
      this.createContactForm();
    } else {
      this.formGroupId = this.item['value']
      if (this.formGroupId != null) {
        this.createDynamicForm(this.formGroupId);
      } else {
        console.log("Form Not Selected");

      }

    }

    this.text = 'Submit';
  }

  createContactForm() {
    this.firstFormGroup = this._formBuilder.group({
      id: [''],
      name: ['', [Validators.required]],
      telephone: ['', [Validators.required]],
      emailId: ['', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$'),]],
      subject: ['', [Validators.required]],
      message: ['', [Validators.required]],
      isActive: new UntypedFormControl(0)
    });
  }


  createDynamicForm(formGroupId) {
    this.contactService.getDynmaicForm(formGroupId).subscribe((data) => {

      let value: any = data
      this.regConfig = value;
      this.gaId = this.regConfig[0].gaTrackingId;
      this.formGroupId = formGroupId;

      this.init = true;
    });
  }

  createContact() {

    this.firstFormGroup.value.operationType = "New"

    if (this.firstFormGroup.valid && this.text == 'Submit') {
      if (this.router.url.split('?')[0] === '/indianabacus-prebooking') {
        const formValues = this.firstFormGroup.value;
        localStorage.setItem('formValues', JSON.stringify(formValues));
        localStorage.setItem('formSubmittedOnChan', 'true');
        this.snackBar.open(this.customField28 || 'Details saved successfully.', '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
        return;
      }

      this.text = "Processing"
      let uniqueId: any = this.generateUniqueId();
      this.setConversionTrackingId();
      this.setFacebookConverison(uniqueId, 1);
      this.contactService.createContact(this.firstFormGroup.value).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.snackBar.open(this.customField28, '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
            this.text = "Submit";
            // this.firstFormGroup.reset();
          } else {
            this.text = "Submit";

            this.snackBar.open(this.customField29, '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
          }
        })
    } else {
      this.firstFormGroup.markAllAsTouched();
    }

  }




  setConversionTrackingId() {

    let grandTotal: any = '1.0';
    let value: any = localStorage.getItem('currency');
    this.googleAnalyticsService.event('purchase', grandTotal);
    if (this.gaId != null) {

      this.googleAnalyticsService.eventEmitter
        ('conversion', this.gaId,
          grandTotal,
          value, this.formGroupId);
    }
    else if (this.data['coversionTrackingIdGa'] != null) {
      this.googleAnalyticsService.eventEmitter
        ('conversion', this.data['coversionTrackingIdGa'],
          grandTotal,
          value, this.formGroupId);
    }
  }

  setFacebookConverison(uniqueId, grandTotal) {
    let value: any = localStorage.getItem('currency');
    this.pixelService.track('Purchase', {
      content_ids: uniqueId,
      value: grandTotal,
      currency: value
    });
    this.pixelService.track('Lead', {
      content_ids: uniqueId,
      value: grandTotal,
      currency: value
    });
  }

  generateUniqueId(): string {
    // Generate a unique ID using Renderer2
    return Math.random().toString(36).substring(2) + Date.now().toString(36);
  }

  submit(value: any) {

    let currentURL = window.location.href;

    value.formId = this.item['value'];

    value.title = this.item['title'];

    value.currentURL = window.location.href;

    let uniqueId: any = this.generateUniqueId();
    value.uniqueFormId = uniqueId;

    let filteredList = this.regConfig
      .filter(item => item.inputType.toLowerCase().includes('button'))
      .map(item => ({ label: item.label }));


    filteredList.forEach(label => {
      if (value.hasOwnProperty(label.label)) {
        delete value[label.label];
      }
    });

    let filteredListFile = this.regConfig
      .filter(item => item.inputType.toLowerCase().includes('file'))
      .map(item => ({ label: item.name }));

    filteredListFile.forEach(label => {
      if (value.hasOwnProperty(label.label)) {
        const newKey = label.label + '_file';
        value[newKey] = value[label.label];
        delete value[label.label];
      }
    });


    let supplierIds = '';

    Object.keys(value).forEach(key => {
      const fieldConfig = this.regConfig.find(
        f => f.name === key || f.label === key
      );

      if (
        fieldConfig &&
        fieldConfig.label?.toLowerCase().includes('vendors') &&
        Array.isArray(value[key])
      ) {
        supplierIds = value[key].join(',');
        delete value[key];
      }
    });

    let object = {};
    let keysToCheck = ["phoneNumber", "email", "name"];
    let keysList = keysToCheck.filter(key => value.hasOwnProperty(key));
    keysList.forEach(key => {
      object[key] = value[key];
    });

    object['formGroupId'] = this.item['value'];

    object['value'] = JSON.stringify(value);

    object['supplierIds'] = supplierIds;


    if (this.router.url.split('?')[0] === '/indianabacus-prebooking') {
      localStorage.setItem('formValues', JSON.stringify(object));
      localStorage.setItem('formSubmittedOnChan', 'true');
      this.snackBar.open(this.customField28 || 'Details saved successfully.', '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
      return;
    }


    if (this.customField31 == 1) {
      this.saveForm(object);
    } else if (this.customField31 == 2) {
      this.Calculation(object);
    } else if (this.customField31 == 3) {
      this.Register(object);
    } else if (this.customField31 == 4) {
      this.onSubmitRoohi(object);
    } else {
      this.SubmitVendor(object);
    }
  }

  Register(object) {

    if (this.text == 'Submit') {

      if (object.plan == null) {
        object.plan = 6;
      }

      this.text = "Processing"

      if (object.operationType = "New") {
        this.deployService.AddNewSite(object).subscribe(
          (response) => {

            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.text = "Submit";
              this.disabledButton = false;
              this.snackBar.open(this.customField28, '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
              this.router.navigate([this.customField10]);
            }
            else {
              this.text = "Submit";
              this.disabledButton = false;
              this.snackBar.open(this.customField29, '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
            }
          },
          (err) => {
            this.disabledButton = false;
            this.text = "Submit"
          });
      }
      else {

      }
    }

  }

  saveForm(object) {
    if (this.text == 'Submit') {

      this.text = "Processing"

      this.contactService.saveForm(object).subscribe(
        (response) => {

          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {

            this.disabledButton = false;

            this.text = "Submit";

            this.customField28 = 'Form Submitted SuccessFully';

            this.snackBar.open(this.customField28, '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });

            if (this.gaId != null) {
              this.setConversionTrackingId();

              let value: any = localStorage.getItem('currency');
              this.pixelService.track('Purchase', {
                content_ids: this.formGroupId,
                value: 1,
                currency: value
              });
              this.pixelService.track('Lead', {
                content_ids: this.formGroupId,
                value: 1,
                currency: value
              });
            }


            if (this.router.url.split('?')[0] === '/indianabacus-prebooking') {
              localStorage.setItem('formSubmittedOnChan', 'true');
            } else {
              this.router.navigate([this.customField10]);
            }
          }
          else {
            this.disabledButton = false;
            this.text = "Submit";
            this.snackBar.open(this.customField29, '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
          }
        },
        (err) => {
          this.disabledButton = false;
          this.text = "Submit"
        });
    }
    else {

    }
  }

  onSubmitRoohi(object) {

    console.log(object);

    localStorage.setItem('formValues', JSON.stringify(object));

    this.contactService.saveFormNew(object).subscribe(
      (response) => {

        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.text = "Submit";
          this.snackBar.open('Form Submitted SuccessFully!', 'X', {
            duration: 5000,
            verticalPosition: 'bottom',
            panelClass: ['success'],
          });
          if (this.router.url.split('?')[0] === '/indianabacus-prebooking') {
            localStorage.setItem('formSubmittedOnChan', 'true');
          }
        }
        else {
          this.text = "Submit";
          this.snackBar.open('Form Submitted Failed!', 'X', {
            duration: 5000,
            verticalPosition: 'bottom',
            panelClass: ['error'],
          });
        }
      },
      (err) => {
        this.disabledButton = true;
        this.text = "Submit"
      });

  }


  SubmitVendor(object) {

    if (this.text == 'Submit') {

      if (object.address == null) {
        object.address = 0;
      }

      if (object.gstNo == null) {
        object.gstNo = 0;
      }

      if (object.phoneNo == null) {
        object.phoneNo = 0;
      }

      if (object.pincode == null) {
        object.pincode = 0;
      }

      if (object.state == null) {
        object.state = 0;
      }

      if (object.city == null) {
        object.city = 0;
      }

      if (object.accountNo == null) {
        object.accountNo = 0;
      }

      if (object.confirmAccount == null) {
        object.confirmAccount = 0;
      }

      if (object.ifscCode == null) {
        object.ifscCode = 0;
      }

      if (object.storeName == null) {
        object.storeName = 0;
      }

      if (object.country == null) {
        object.country = 'India';
      }

      if (object.email == null) {
        object.email = 0;
      }

      if (object.password == null) {
        object.password = 0;
      }

      this.text = "Processing"

      if (object.operationType = "New") {
        this.supplierRegistrationService.submitSupplier(object).subscribe(
          (response) => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.text = "Submit";

              this.snackBar.open(this.customField28, '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
              this.router.navigate([this.customField10]);
            }
            else {
              this.text = "Submit";
              this.snackBar.open(this.customField29, '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
            }
          },
          (err) => { this.text = "Submit" });
      }
      else {

      }
    }


  }

  Calculation(object) {

    const parsedValue = JSON.parse(object.value);

    const calculatedResult = parsedValue.calculatedResult;

    console.log('Calculated Result:', calculatedResult);
    console.log('Parsed Object:', parsedValue);

    this.disabledButton = false;

  }




}
